import { FREE_TRIAL_APPLICATION_CREDITS } from "@src/config/freeTrial";
import {
    ELITE_APPLICATION_CREDITS,
    PROFESSIONAL_APPLICATION_CREDITS,
    ULTIMATE_APPLICATION_CREDITS,
} from "@src/config/planCredits";

export interface FAQItem {
    question: string;
    answer: string;
}

export const homepageFAQ: FAQItem[] = [
    {
        question: "How does LifeShack choose which jobs to apply to?",
        answer:
        "When setting up LifeShack, you specify the type of work you are seeking.\n\nWe then <i>continuously</i> perform a job search based on your criteria, and we evaluate each opportunity to ensure it is a job you're interested in.\n\nIf we determine there is a <b>strong match</b>, we complete your job application - factoring in your resume, work experience, and additional information.",
    },
    {
        question: "What types of jobs does LifeShack apply to?",
        answer:
        "We currently support <b>full-time remote, hybrid, and onsite roles</b> at some of the best companies in the world.\n\nOur system is <i>growing every day</i> to accommodate more geographies, industries, and part-time roles.",
    },
    {
        question: "Where do you find your jobs?",
        answer:
        "We search employer and job-platform sources for roles that match the preferences in your profile.\n\nLifeShack currently supports job workflows across more than <b>100,000 companies</b> worldwide.",
    },
    {
        question: "Can I customize my applications?",
        answer:
        "<b>Yes</b>, LifeShack customizes each application based on your resume, experience, and specific job requirements.\n\nYou can also adjust preferences in your account settings to <i>tailor applications to your strengths</i>.",
    },
    {
        question: "Does LifeShack apply to jobs automatically?",
        answer:
        "<b>Yes</b>. Once you've set up your preferences, LifeShack can automatically prepare and submit supported applications for matching roles.\n\nKeep your profile current and review application activity because employer-specific questions and portal changes can require additional input.",
    },
    {
        question: "How many jobs does LifeShack apply to per month?",
        answer:
        `The number of applications depends on the plan you choose.\n\nOur Professional plan includes up to <b>${PROFESSIONAL_APPLICATION_CREDITS} applications</b> per month, Ultimate allows <b>${ULTIMATE_APPLICATION_CREDITS}</b>, and Elite offers <b>${ELITE_APPLICATION_CREDITS}</b>.`,
    },
    {
        question: "Is there a free trial?",
        answer:
        `<b>Yes</b>. The free trial includes <b>${FREE_TRIAL_APPLICATION_CREDITS} application credits</b> so you can see LifeShack submit matched applications before choosing a paid plan. No credit card is required to get started.`,
    },
    {
        question: "Does LifeShack guarantee interviews or job offers?",
        answer:
        "No. LifeShack cannot guarantee an interview, job offer, or other employment outcome. It reduces repetitive application work so you can maintain a consistent search and spend more time on networking, research, and interview preparation.",
    },
    {
        question: "How does LifeShack ensure applications stand out?",
        answer:
        "LifeShack can use the job description and information in your profile to prepare <b>role-specific cover-letter and resume drafts</b>. Keep your source information accurate and review generated materials before using them.",
    },
    {
        question: "Is LifeShack available for international job seekers?",
        answer:
        "LifeShack searches roles across multiple countries and industries, but availability and supported application workflows vary by region, employer, and job platform.",
    }
];
